import { render, staticRenderFns } from "./PhrCodeInsertPopUp.vue?vue&type=template&id=04873dfa&scoped=true&"
import script from "./PhrCodeInsertPopUp.vue?vue&type=script&lang=js&"
export * from "./PhrCodeInsertPopUp.vue?vue&type=script&lang=js&"
import style0 from "./PhrCodeInsertPopUp.vue?vue&type=style&index=0&id=04873dfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04873dfa",
  null
  
)

export default component.exports